import { useAuth } from "@/context/auth";
import HomeViewSwitch from "@/modules/mobileHome/HomeViewSwitch";
import SalonHeader from "@/modules/mobileHome/SalonHeader";
import { isoDate } from "@/modules/mobileHome/format";
import { myVisitHint, stylistDay } from "@/modules/mobileHome/stylistDay";
import useHomeView from "@/modules/mobileHome/useHomeView";
import useNow from "@/modules/mobileHome/useNow";
import { useGetDailyAppointment } from "@/services/appointment/hooks/useGetDailyAppointment";
import useGetMerchantUsers from "@/services/merchantUser/hooks/useGetMerchantUsers";
import { useMemo } from "react";
import Home from ".";
import StylistHome from "./StylistHome";

// A manager's mobile home. One who also takes clients (has services of their own in the team) can switch
// between the salon's home and their own day as a stylist; the choice is remembered on this device.
export default function ManagerHome() {
  const phone = useAuth().getUserByToken()?.phoneNumber ?? "";
  const team = useGetMerchantUsers();
  const { view, stored, choose } = useHomeView(phone);
  const self = team.data?.find((user) => user.phoneNumber === phone);
  // Until the team arrives, a choice made before means the switch was there last time.
  const takesClients = team.data ? Boolean(self?.merchantServices?.length) : stored !== null;

  // Same request as the salon home's list, so this costs nothing extra.
  const today = useMemo(() => isoDate(new Date()), []);
  const calendar = useGetDailyAppointment({ fromDate: today, toDate: today });
  const now = useNow();
  const myVisit = useMemo(
    () => (self?.id && calendar.data ? myVisitHint(stylistDay(calendar.data, self.id, now), now) : undefined),
    [self?.id, calendar.data, now],
  );

  if (!takesClients) return <Home />;

  const top = (
    <>
      <SalonHeader />
      <HomeViewSwitch value={view} onChange={choose} myVisit={myVisit} />
    </>
  );
  return view === "me" ? <StylistHome top={top} memberScope={self?.id} /> : <Home top={top} />;
}
